import { SVGProps } from 'react';

export default function FeedPlay(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M10.5433 7.49857L16.2025 11.1604C16.8115 11.5545 16.8115 12.4455 16.2025 12.8396L10.5433 16.5014C9.87789 16.932 9 16.4544 9 15.6619L9 8.33814C9 7.54564 9.87789 7.06804 10.5433 7.49857Z" fill="white" />
    </svg>
  )
}